import { debugConsole } from '@aio/utils';
/**
 * @TODO 临时皮克活动 下架删除
 */

import { ACTIVITY_STATUS, SORTRULES } from '@/schemas/coupon';
import * as services from '@services/index';

interface IState {
  isReceived: boolean; // 优惠券已领取过
  hasCoupons: boolean; // 有券可用
}

const initState: IState = {
  isReceived: false,
  hasCoupons: false
};

const dermatologicalActivity = {
  state: initState,

  reducers: {
    updateState(state: IState, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (dispatch) => ({
    setCouponStatus(isReceived: boolean) {
      this.updateState({
        isReceived
      });
    },
    async getCoupons(activityCode: string) {
      // 触发分享成功回掉 然后再发起领取优惠券的请求
      try {
        const res = await services.coupon.receiveCoupon({
          activityCode
        });

        this.updateState({
          isReceived: true
        });

        return res || Promise.reject();
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async checkCoupons(couponCategoryId: number | undefined) {
      if (!couponCategoryId) {
        debugConsole('当前优惠券couponCategoryId为空');
        return;
      }

      try {
        const res = await services.coupon.getCouponData({
          couponStatus: ACTIVITY_STATUS.UNCLAIMED,
          pageNum: 1,
          pageSize: 99,
          sortRules: SORTRULES.AVAILABLE_AND_PRICE
        });

        const hasCoupons =
          res?.list.some((i) => i.couponCategoryId === couponCategoryId) ??
          false;

        this.updateState({
          hasCoupons
        });
      } catch (err) {
        //
      }
    }
  })
};

export default dermatologicalActivity;
